import { useParams } from "react-router-dom";
import { useGetAllNotesQuery, useGetAllPersonsQuery, useSyncPersonsQuery } from "@/services/api";
import { CONTACTS_SYNC_INTERVAL } from "../constants";

export const useContactsPage = () => {
  const { data, isLoading: personsIsLoading } = useGetAllPersonsQuery();

  const { isLoading: notesIsLoading } = useGetAllNotesQuery();

  const { personId } = useParams();

  useSyncPersonsQuery(data?.syncDate ?? "", {
    pollingInterval: CONTACTS_SYNC_INTERVAL,
    skip: !data || !data?.syncDate,
  });

  return {
    isLoading: personsIsLoading || notesIsLoading,
    isEmpty: data?.count === 0 && !personId,
  };
};
